function navbar(theme) {
  const {palette} = theme;
  const {white} = palette;

  return {
    boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    backdropFilter: "none",
    backgroundColor: white.main,
    position: "fixed",
    top: 0,
    right: 0,
    width: "calc(100% - 250px)",
    minHeight: "64px",
    display: "flex",
    alignItems: "center",
    margin: 0,
    padding: 0,
    borderBottom: "1px solid #e2e8f0",
    zIndex: 1000
  };
}

const navbarContainer = () => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  width: "100%",
  height: "100%",
  padding: 0
});

const navbarRow = () => ({
  display: "flex",
  alignItems: "center",
  width: "100%",
  padding: 0
});

const navbarIconButton = () => ({
  width: "40px",
  height: "40px",
  minWidth: "40px",
  padding: "8px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "& .MuiSvgIcon-root": {
    fontSize: "20px",
    color: "#64748b"
  },

  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)"
  }
});

const navbarMobileMenu = () => ({
  padding: "8px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",

  "& .MuiIcon-root": {
    fontSize: "24px",
    color: "#64748b"
  },

  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)"
  }
});

export {navbar, navbarContainer, navbarRow, navbarIconButton, navbarMobileMenu};
